import "core-js/modules/es.object.assign.js";
import Vue from 'vue';
import Vuex from 'vuex'; // 全局

import * as actions from './actions';
import * as getters from './getters'; // 模块

import home from './home';
import venues from './venues';
import question from './question';
import fansBuy from './fansBuy';
import venueDetail from './venue-detail';
import misc from './misc';
import groupList from './group-list';
import address from './address';
Vue.use(Vuex);
export default new Vuex.Store({
  modules: Object.assign({
    home: home,
    question: question,
    fansBuy: fansBuy,
    venues: venues,
    venueDetail: venueDetail,
    groupList: groupList
  }, misc, {
    address: address
  }),
  actions: actions,
  getters: getters
});